<template>
    <div class="content-login mt-5 row justify-content-center ">
      <div class="card w-25" >
        <div class="card-header">
          <h1 class="text-center">Bienvenido {{userName}}</h1>
        </div>
        <div class="card-body login">
            <div class="logo"></div>
            <div class="form">
              <div class="form-floating mb-3">
                <input type="password" class="form-control" v-model="passwordData.claveNueva" placeholder="Clave Nueva">
                <label for="floatingInput">Ingresar Clave Nueva</label>
              </div>
              <div class="form-floating mb-3">
                <input type="password" class="form-control" v-model="passwordData.confirmarClave" placeholder="Confirmar Clave Nueva">
                <label for="floatingInput">Confirmar Clave Nueva</label>
              </div>
              <br />
              <button type="button" class="btn btn-primary justify-content-center w-100 " @click="recuperarPassword">Confirmar Cambio Clave</button>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { utils } from '@/utils.js'

export default {
  props: {
    codigoRecover: String,
    userId: String,
    userName: String
  },
  mixins: [utils],
  data () {
    return {
      passwordData: { claveNueva: null, confirmarClave: null }
    }
  },
  methods: {

    recuperarPassword () {
      const data = {
        codigoRecover: this.codigoRecover ?? this.$route.params.codigoRecover,
        userId: this.userId ?? this.$route.params.userId,
        username: this.userName ?? this.$route.params.userName,
        passwordData: this.passwordData.claveNueva,
        confirmarClave: this.passwordData.confirmarClave
      }
      axios.put('/users/recover_password/', data).then(res => {
        this.successNotification(res.data.message)
        this.$router.replace({ path: '/' })
      }).catch(error => {
        this.errorNotification(error.response.data.message)
      })
    },
    tiempoExpiracion () {
      const username = this.userName ?? this.$route.params.userName
      axios.get(`/users/tiempo_expiracion/${username}`).then(res => {
        const respuesta = res.data.message
        const condicion = Boolean(respuesta)
        if (!condicion) {
          this.errorNotification('El tiempo ya expiro')
          return this.$router.replace({ path: '/' })
        }
      })
    },
    linkUsed () {
      const username = this.userName ?? this.$route.params.userName
      axios.get(`/users/link_used/${username}`).then(res => {
        // this.successNotification(res.data.message)
      }).catch(res => {
        this.errorNotification('No es posible ocupar el link mas de una vez.')
        return this.$router.replace({ path: '/' })
      })
    }
  },
  mounted () {
    this.linkUsed()
    this.tiempoExpiracion()
  }
}
</script>
